import "./rlAdmin.vendors";
import "./rlAdmin.mixins";

import * as angular from 'angular';
import * as moment from "moment";

import rlServicesModule from "./rlAdmin.services";
import multiTranscludeModule from "../libraries/rl-multi-transclude";

import { rlAdminDirectivesModule } from "./rlAdmin.directives";
import { rlAdminConstsModule } from "./rlAdmin.consts";
import { rlAdminFiltersModule } from "./rlAdmin.filters";
import { rlAdminCharDirectivesModule } from "./rlAdmin.chardatadirectives";
import {
	LayoutController,
	RecordCreateController,
	DashboardMyNewDealsController,
	DashboardMyOpenDealsController,
	TestEntityController,
	RecordDetailController,
	AvailabilityReportController,
	RoyaltyStatementController,
	DealSearchReportController,
	QuickLinksMenuController,
	ChartController,
	TestTreeController,
	AvailabilityExplorerController,
	AccountManageController,
	NewPasswordController,
	AclTestController,
	TitleCoverageController,
	StyleTest2Controller,
} from "./rlAdmin.controllers";
import { GenericSearchController } from '../controllers/_baseSearchController';
import { DealSummaryController } from "../controllers/deals/deal-summary-controller";
import { ContactCreateController, ContactSecurityController, ContactFilesController, ContactEntityAssociationSearchController } from "../ts/rlAdmin.controllers.mod2";
import { AssetSearchController } from "../controllers/search/asset-search-controller";
import { AssetAssociationsController, EntityAttachmentController, AssetFilesController, AssetEntityAssociationSearchController } from "../ts/rlAdmin.controllers.mod1";
import { JobSummaryController, JobDetailsController, JobInventoryController, JobDocumentsController, JobsEntityAssociationSearchController } from "../ts/rlAdmin.controllers.mod15";
import { ProjectDetailsController, ProjectSummaryController, ProjectInventoryController, ProjectEntityAssociationSearchController, ProjectDocumentsController } from "../ts/rlAdmin.controllers.mod16";

import { UsagesController } from "../controllers/usages/usages-controller";
import { ContactAssociationsController } from "../directives/associate-contacts";
import { AssetRightsController } from "../controllers/assets/asset-rights-controller";
import { ContractSearchController } from "../controllers/search/contract-search-controller";
import { ContactSearchController } from "../controllers/search/contact-search-controller";
import { FinancialSearchController } from "../controllers/search/financial-search-controller";
import { JobSearchController } from "../controllers/search/job-search-controller";
import { ProjectSearchController } from "../controllers/search/project-search-controller";
import { InventorySearchController } from "../controllers/search/inventory-search-controller";

import { DataExportController } from "../controllers/reports/data-export-controller";
import { SSRSReportController } from "../controllers/reports/ssrs-report-controller";
import { CatalogAvailabilityController, CatalogAvailsReportController } from "../controllers/reports/catalog-availability-controller";
import { AvailabilityController } from "../controllers/reports/availability-windows-controller";
import { FinancialDetailController } from "../ts/rlAdmin.controllers.mod7";
import { ContractDetailsController } from "../controllers/deals/deal-details-controller";
import { DealRightsController } from "../controllers/deals/deal-rights-controller";
import { DealAssetsController } from "../controllers/deals/deal-assets-controller";
import { ContractSummaryAssetsController } from "../controllers/deals/deal-summary-assets-controller";
import { ContractInventoryController, ContractDocumentsController, ContractFinancialsController, ContractEntityAssociationSearchController } from "../ts/rlAdmin.controllers.mod4";
import { IndexAdminController } from '../config/controllers/index-admin-controller';
import { ContractRoyaltiesController } from "../controllers/deals/deal-royalties-controller";
import { InventoryCreateController, InventoryDetailController, InventoryEntityAssociationSearchController } from "../ts/rlAdmin.controllers.mod17";
import { DealRightsManagerController } from "../controllers/deals/deal-rights-manager-controller";
import { BaseAssociationSearchController } from '../controllers/base-associations-search-controller';
import { LoginController } from "../controllers/accounts/loginController";
import { SupportPortalController } from "../controllers/accounts/support-portal-controller";
import { AdHocTreeCustomPopupController } from "../controllers/reports/adhoc-tree-custom-popup-controller";
import { AdHocSpParamCustomPopupController } from "../controllers/reports/adhoc-spparam-custom-popup-controller";
import { AdminController } from "../config/controllers/admin-controller";
import { EditCharacteristicController, CacheAdminController, JobAdminController, WorkflowActionConfigController, WorkflowStepConfigController, WorkflowProcessConfigController, WorkflowNotificationConfigController, SecurityRoleConfigController, SecurityStepConfigController, SecurityActionConfigController, HierarchyValueSetController, ValueSourceGroupController, EditTemplateCharacteristicController, PolicyListController, EditPolicyActivitiesController, IdentityRoleConfigController } from "../ts/rlAdmin.controllers.config";
import { CurrencyConversionConfigController } from "../config/controllers/currency-conversion-config-controller";
import { AmortizationConfigController } from "../config/controllers/amortization-config-controller";
import { CatalogSettingsConfigController } from "../config/controllers/catalog-settings-config-controller";
import { OverviewConfigController } from "../config/controllers/overview-config-controller";
import { FinancialPeriodController } from "../config/controllers/financial-period-controller";
import { BillingConfigController } from "../config/controllers/billing-config-controller";
import { ManualStatusUpdateController } from "../config/controllers/manual-status-update-controller";
import { DataExportAdminController } from "../config/controllers/bulk-export-controller";
import { HierarchyController } from "../config/controllers/hierarchy-controller";
import { DocGenConfigController } from "../config/controllers/doc-gen-config-controller";
import { EntityStatusAdminController } from "../config/controllers/entity-status-admin-controller";
import { TemplateConfigController } from "../config/controllers/template-config-controller";
import { EditPolicyPermissionsController } from "../config/controllers/edit-policy-permissions-controller";
import { PartyGroupListController } from "../directives/edit-party-group-list";
import { DebugQueryNodeController } from "../config/controllers/debug-query-node-controller";
import { RelativeRightsProfilesController } from "../config/controllers/relative-rights-profiles-controller";
import { AvailsCalcAdminController } from "../config/controllers/avails-calc-admin-controller";
import { WorkflowController } from "../controllers/workflow/workflow-controller";
import { RightsDimensionsSettingsConfigController } from "../config/controllers/rights-dimensions-config-controller";



let rlAdminApp = angular.module("rlAppModule", [rlAdminConstsModule.name, rlServicesModule.name, rlAdminDirectivesModule.name, rlAdminCharDirectivesModule.name, rlAdminFiltersModule.name,
	"ngAnimate", "ngResource", "ngSanitize", "ngCookies", "ngMessages", "ngAnimate",
	"textAngular", "ui.bootstrap", "ang-drag-drop", multiTranscludeModule.name, "vs-repeat", "as.sortable", "colorpicker.module"]);

//angular.bootstrap(document, ['rlAdminApp'], {
//    strictDi: true
//});

rlAdminApp.run(["$window", ($window: ng.IWindowService) => {
	if (moment.localeData($window.navigator.language) != null) {
		moment.locale($window.navigator.language);
	} else {
		moment.locale("en");
	}
}]);

declare var DEBUG_NG;
if (!DEBUG_NG) {
	rlAdminApp.config(["$compileProvider", function ($compileProvider) {
		// disable debug info
		$compileProvider.debugInfoEnabled(false);
	}]);
}

rlAdminApp.config(["$provide", ($provide) => {
	$provide.decorator('taOptions', ['taRegisterTool', '$delegate', (taRegisterTool, taOptions) => {
		taOptions.forceTextAngularSanitize = false;
		return taOptions;
	}]);
}]);

// Controllers
rlAdminApp
	.controller("layoutController", LayoutController)
	.controller("contractSummaryController", DealSummaryController)
	.controller("recordCreateController", RecordCreateController)
	.controller("contactCreateController", ContactCreateController)
	.controller("assetSearchController", AssetSearchController)
	.controller("dashboardMyNewDealsController", DashboardMyNewDealsController)
	.controller("dashboardMyOpenDealsController", DashboardMyOpenDealsController)
	.controller("assetAssociationsController", AssetAssociationsController)
	.controller("usagesController", UsagesController)
	.controller("contactAssociationsController", ContactAssociationsController)
	.controller("testEntityController", TestEntityController)
	.controller("recordDetailController", RecordDetailController)
	.controller("assetRightsController", AssetRightsController)
	.controller("contractSearchController", ContractSearchController)
	.controller("contactSearchController", ContactSearchController)
	.controller("availabilityReportController", AvailabilityReportController)
	.controller("financialSearchController", FinancialSearchController)
	.controller("dataExportController", DataExportController)
	.controller("ssrsReportController", SSRSReportController)
	.controller("catalogAvailsReportController", CatalogAvailsReportController)
	.controller("royaltyStatementController", RoyaltyStatementController)
	.controller("dealSearchReportController", DealSearchReportController)
	.controller("availsWindowReportController", AvailabilityController)
	.controller("financialDetailController", FinancialDetailController)
	.controller("contractDetailsController", ContractDetailsController)
	.controller("contractRightsController", DealRightsController)
	.controller("contractAssetsController", DealAssetsController)
	.controller("contractSummaryAssetsController", ContractSummaryAssetsController)
	.controller("contractInventoryController", ContractInventoryController)
	.controller("contractDocumentsController", ContractDocumentsController)
	.controller("contractFinancialsController", ContractFinancialsController)
	.controller("quickLinksMenuController", QuickLinksMenuController)
	.controller("indexAdminController", IndexAdminController)
	.controller("contactSecurityController", ContactSecurityController)
	.controller("contractRoyaltiesController", ContractRoyaltiesController)
	.controller("inventoryCreateController", InventoryCreateController)
	.controller("entityAttachmentController", EntityAttachmentController)
	.controller("inventoryDetailController", InventoryDetailController)
	.controller("chartController", ChartController)
	.controller("contractRightsManagerController", DealRightsManagerController)
	.controller("testTreeController", TestTreeController)
	.controller("availabilityExplorerController", AvailabilityExplorerController)
	.controller("accountManageController", AccountManageController)
	.controller("newPasswordController", NewPasswordController)
	.controller("aclTestController", AclTestController)
	.controller("jobSearchController", JobSearchController)
	.controller("jobSummaryController", JobSummaryController)
	.controller("jobDetailsController", JobDetailsController)
	.controller("jobInventoryController", JobInventoryController)
	.controller("jobDocumentsController", JobDocumentsController)
	.controller("titleCoverageController", TitleCoverageController)
	.controller("baseAssociationSearchController", BaseAssociationSearchController)
	.controller("assetFilesController", AssetFilesController)
	.controller("jobsEntityAssociationSearchController", JobsEntityAssociationSearchController)
	.controller("projectSearchController", ProjectSearchController)
	.controller("projectSummaryController", ProjectSummaryController)
	.controller("projectDetailsController", ProjectDetailsController)
	.controller("projectInventoryController", ProjectInventoryController)
	.controller("projectEntityAssociationSearchController", ProjectEntityAssociationSearchController)
	.controller("projectDocumentsController", ProjectDocumentsController)
	.controller("contactFilesController", ContactFilesController)
	.controller("genericSearchController", GenericSearchController)
	.controller("inventorySearchController", InventorySearchController)
	.controller("contactEntityAssociationSearchController", ContactEntityAssociationSearchController)
	.controller("assetEntityAssociationSearchController", AssetEntityAssociationSearchController)
	.controller("inventoryEntityAssociationSearchController", InventoryEntityAssociationSearchController)
	.controller("contractEntityAssociationSearchController", ContractEntityAssociationSearchController)
	.controller("styleTest2Controller", StyleTest2Controller)
	.controller("loginController", LoginController)
	.controller("supportPortalController", SupportPortalController)

	// Izenda
	.controller("adHocTreeCustomPopupController", AdHocTreeCustomPopupController)
	.controller("adHocSpParamCustomPopupController", AdHocSpParamCustomPopupController)
	.controller("editCharacteristicController", EditCharacteristicController)
	.controller("cacheAdminController", CacheAdminController)
	.controller("adminController", AdminController)
	.controller("currencyConversionConfigController", CurrencyConversionConfigController)
	.controller("amortizationConfigController", AmortizationConfigController)
    .controller("catalogSettingsConfigController", CatalogSettingsConfigController)
    .controller("rightsDimensionsSettingsConfigController", RightsDimensionsSettingsConfigController)
	.controller("relativeRightsProfilesController", RelativeRightsProfilesController)
	.controller("overviewConfigController", OverviewConfigController)
	.controller("billingConfigController", BillingConfigController)
	.controller("manualStatusUpdateController", ManualStatusUpdateController)
	.controller("bulkExportAdminController", DataExportAdminController)
	.controller("financialPeriodController", FinancialPeriodController)
	.controller("jobAdminController", JobAdminController)
	.controller("hierarchyController", HierarchyController)
	.controller("workflowActionConfigController", WorkflowActionConfigController)
	.controller("workflowStepConfigController", WorkflowStepConfigController)
	.controller("workflowProcessConfigController", WorkflowProcessConfigController)
	.controller("workflowNotificationConfigController", WorkflowNotificationConfigController)
	.controller("securityRoleConfigController", SecurityRoleConfigController)
	.controller("securityStepConfigController", SecurityStepConfigController)
	.controller("securityActionConfigController", SecurityActionConfigController)
	.controller("docGenConfigController", DocGenConfigController)
	.controller("hierarchyValueSetController", HierarchyValueSetController)
	.controller("valueSourceGroupController", ValueSourceGroupController)
	.controller("editTemplateCharacteristicController", EditTemplateCharacteristicController)
	.controller("entityStatusAdminController", EntityStatusAdminController)
	.controller("templateConfigController", TemplateConfigController)
	.controller("policyListController", PolicyListController)
	.controller("editPolicyPermissionsController", EditPolicyPermissionsController)
	.controller("editPolicyActivitiesController", EditPolicyActivitiesController)
	.controller("identityRoleConfigController", IdentityRoleConfigController)
	.controller("partyGroupListController", PartyGroupListController)
	.controller("debugQueryNodeController", DebugQueryNodeController)
	.controller("availsCalcAdminController", AvailsCalcAdminController)
	.controller("workflowController", WorkflowController)



angular.element(document).ready(() => {
	var rlAdminServices = angular.module(rlServicesModule.name);
	var injector = angular.injector(["ng"]);
	var $http = injector.get<ng.IHttpService>("$http");
	$http.get<string[]>("/api/account/getacls")
		.then((result) => {
			rlAdminServices.constant("ACL_SERVICES_ACLS", result.data);
			angular.bootstrap(document.body, [rlAdminApp.name], { strictDi: true });
		}, (err) => {
			console.error(err);
		});
});



